import { handleActions } from 'redux-actions'
import * as type from './type'
import { COMPANY_CODE_SUNSHINE_SMILE_GERMANY } from '../../../internationalization/const'
import { changeTableSettings, createInitialTableState } from '../../../form/state/table-state-helper'


export const initialState = {
    userSelection: {
        processName: null,
        responsible: null,
        companyCode: COMPANY_CODE_SUNSHINE_SMILE_GERMANY,
    },
    stateAnalytics: null,

    fetching: false,
    error: null,

    taskByDueDateList: null,
    currentTaskName: null,
    taskList: null,
    ...createInitialTableState({
        rowsPerPage: 0,
        sortColumnName: 'created',
        sortOrder: -1,
    }, 'taskListTableSettings'),

    currentStateName: null,
    stateByLastChangedList: null,
    processInstanceList: null,
    ...createInitialTableState({
        rowsPerPage: 0,
        sortColumnName: 'created',
        sortOrder: -1,
    }, 'stateListTableSettings'),
}


export default handleActions({
    [type.CHANGE_TASK_TABLE_SETTINGS]: changeTableSettings('taskListTableSettings'),
    [type.CHANGE_STATE_TABLE_SETTINGS]: changeTableSettings('stateListTableSettings'),

    [type.CHANGE_USER_SELECTION]: (state, action) => {
        const { name, value } = action.payload
        return {
            ...state,
            userSelection: {
                ...state.userSelection,
                [name]: value,
            },
        }
    },
    [type.GET_STATE_ANALYTICS_REQUEST]: (state, action) => {
        return {
            ...state,
            fetching: true,
            error: null,
            currentTaskName: null,
            currentStateName: null,
            taskList: null,
            processInstanceList: null,
            stateByLastChangedList: null,
            taskByDueDateList: null,
        }
    },
    [type.GET_STATE_ANALYTICS_ERROR]: (state, action) => {
        const { error } = action.payload
        return {
            ...state,
            fetching: false,
            error,
        }
    },
    [type.GET_STATE_ANALYTICS_SUCCESS]: (state, action) => {
        const { stateAnalytics } = action.payload
        return {
            ...state,
            stateAnalytics,
            fetching: false,
        }
    },


    [type.GET_STATE_LAST_CHANGED_REQUEST]: (state, action) => {
        return {
            ...state,
            fetching: true,
            error: null,
            taskByDueDateList: null,
        }
    },
    [type.GET_STATE_LAST_CHANGED_ERROR]: (state, action) => {
        const { error } = action.payload
        return {
            ...state,
            fetching: false,
            error,
        }
    },
    [type.GET_STATE_LAST_CHANGED_SUCCESS]: (state, action) => {
        const { stateByLastChangedList, stateName } = action.payload
        return {
            ...state,
            fetching: false,
            stateByLastChangedList,
            currentStateName: stateName,
            currentTaskName: null,
        }
    },
    [type.FIND_PROCESS_INSTANCE_BY_WEEK_DIFF_DATE_REQUEST]: (state, action) => {
        return {
            ...state,
            fetching: true,
            error: null,
        }
    },
    [type.FIND_PROCESS_INSTANCE_BY_WEEK_DIFF_DATE_ERROR]: (state, action) => {
        const { error } = action.payload
        return {
            ...state,
            fetching: false,
            error,
        }
    },
    [type.FIND_PROCESS_INSTANCE_BY_WEEK_DIFF_DATE_SUCCESS]: (state, action) => {
        const { processInstanceList } = action.payload
        return {
            ...state,
            fetching: false,
            processInstanceList,
        }
    },


    [type.GET_TASK_BY_DUE_DATE_REQUEST]: (state, action) => {
        return {
            ...state,
            fetching: true,
            error: null,
            stateByLastChangedList: null,
        }
    },
    [type.GET_TASK_BY_DUE_DATE_ERROR]: (state, action) => {
        const { error } = action.payload
        return {
            ...state,
            fetching: false,
            error,
        }
    },
    [type.GET_TASK_BY_DUE_DATE_SUCCESS]: (state, action) => {
        const { taskByDueDateList, taskName } = action.payload
        return {
            ...state,
            fetching: false,
            taskByDueDateList,
            currentTaskName: taskName,
            currentStateName: null,
        }
    },
    [type.FIND_TASK_BY_WEEK_DIFF_DATE_REQUEST]: (state, action) => {
        return {
            ...state,
            fetching: true,
            error: null,
        }
    },
    [type.FIND_TASK_BY_WEEK_DIFF_DATE_ERROR]: (state, action) => {
        const { error } = action.payload
        return {
            ...state,
            fetching: false,
            error,
        }
    },
    [type.FIND_TASK_BY_WEEK_DIFF_DATE_SUCCESS]: (state, action) => {
        const { taskList } = action.payload
        return {
            ...state,
            fetching: false,
            taskList,
        }
    },

}, initialState)



// WEBPACK FOOTER //
// ./src/modules/analytics/state/state-responsible/reducer.js